"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MeterReadingsData = void 0;
var react_1 = __importDefault(require("react"));
var legacy_queries_1 = require("../../../../shared/api/legacy-queries");
var core_1 = require("../../../../shared/core");
var with_customer_and_account_ids_1 = require("../../../../shared/core/utils/with-customer-and-account-ids");
var utils_1 = require("../../../usage/utils");
var copy_1 = require("../../copy");
var Error_1 = require("./Error");
var Loading_1 = require("./Loading");
var MeterReadingsQuery_1 = require("./MeterReadingsQuery");
var Data = function (_a) {
    var supplyPoints = _a.supplyPoints, latestBilling = _a.latestBilling, selectedFuel = _a.selectedFuel, accountId = _a.accountId, children = _a.children, NoData = _a.NoData, Error = _a.Error;
    var _b = (0, core_1.useComponents)(), InfoNotification = _b.InfoNotification, Redirect = _b.Redirect;
    var meterReads = (0, core_1.useLinks)().meterReads;
    var Copy = (0, core_1.useCopy)(copy_1.defaultOptions).Copy;
    var gasSupply = supplyPoints.find(utils_1.isActiveGasSupply);
    var elecSupply = supplyPoints.find(utils_1.isActiveElectricitySupply);
    var noSupplies = !gasSupply && !elecSupply;
    var isGasOnly = gasSupply && !elecSupply;
    var isElecOnly = elecSupply && !gasSupply;
    var inactiveFuelSelected = (selectedFuel === 'gas' && isElecOnly) ||
        (selectedFuel === 'electricity' && isGasOnly);
    if (noSupplies) {
        return (react_1.default.createElement(InfoNotification, { id: "info-no-active-supplies", title: react_1.default.createElement(Copy, { copyKey: "noActiveSuppliesTitle" }), "data-testid": "meter-readings-no-active-supplies" },
            react_1.default.createElement(Copy, { copyKey: "noActiveSuppliesMessage" })));
    }
    if (location.pathname !== meterReads() && inactiveFuelSelected) {
        return react_1.default.createElement(Redirect, { to: meterReads() });
    }
    return (react_1.default.createElement(MeterReadingsQuery_1.MeterReadingsQuery, { supplyPoints: supplyPoints, latestBilling: latestBilling, accountId: accountId, NoData: NoData, Error: Error }, children));
};
exports.MeterReadingsData = (0, with_customer_and_account_ids_1.withCustomerAndAccountIds)(function (_a) {
    var selectedFuel = _a.selectedFuel, children = _a.children, accountId = _a.accountId, NoData = _a.NoData, Error = _a.Error;
    var _b = (0, legacy_queries_1.useSupplyPoints)(accountId), loading = _b.loading, error = _b.error, data = _b.data;
    var latestBillingQueryResult = (0, legacy_queries_1.useBillingLegacyQuery)(accountId, 'latest');
    if (error || latestBillingQueryResult.status === 'error') {
        var message = error
            ? 'supplies failed to load'
            : 'billing failed to load';
        return Error ? (react_1.default.createElement(Error, { isFetching: loading || latestBillingQueryResult.isFetching, error: { message: message } })) : (react_1.default.createElement(Error_1.ErrorWithLoading, { isFetching: loading || latestBillingQueryResult.isFetching, error: { message: message } }));
    }
    if (loading ||
        latestBillingQueryResult.isFetching ||
        !data ||
        latestBillingQueryResult.status !== 'data') {
        return NoData ? react_1.default.createElement(NoData, null) : react_1.default.createElement(Loading_1.Loading, null);
    }
    return (react_1.default.createElement(Data, { supplyPoints: data, accountId: accountId, latestBilling: latestBillingQueryResult.data, selectedFuel: selectedFuel, NoData: NoData || Loading_1.Loading, Error: Error || Error_1.ErrorWithLoading }, children));
});
